import type { ReceiptTemplate } from '../schema';

export const homeDepotTemplate: ReceiptTemplate = {
  id: 'home-depot',
  name: 'Home Depot Receipt',
  brand: 'THE HOME DEPOT',
  description: 'Home improvement store receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'hd-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/home-depot.png',
        logoData: '',
        logoWidth: 160,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'STORE #0127',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hd-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '0127 00104 84729    01/04/26 14:21\nCASHIER: MIKE W    SELF CHK',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'hd-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'hd-item-1', name: '2X4X8 STUD', quantity: '10', price: '4.98'},
          { id: 'hd-item-2', name: 'DRYWALL SCREWS 1LB', quantity: '2', price: '8.97'},
          { id: 'hd-item-3', name: 'WOOD GLUE 8OZ', quantity: '1', price: '6.48'},
          { id: 'hd-item-4', name: 'PAINT BRUSH 2IN', quantity: '3', price: '4.97'},
          { id: 'hd-item-5', name: 'DROP CLOTH 9X12', quantity: '1', price: '12.98'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'hd-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'hd-subtotal', label: 'SUBTOTAL', value: '117.19', isBold: false, isLarge: false },
          { id: 'hd-tax', label: 'TAX', value: '10.40', isBold: false, isLarge: false },
          { id: 'hd-total', label: 'TOTAL', value: '127.59', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'hd-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'hd-card', label: 'VISA DEBIT', value: '************4144' },
          { id: 'hd-auth', label: 'APPROVAL', value: '847291' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'hd-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '01270010484729',
        showValue: true,
        width: 1.5,
        height: 40,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'hd-return',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'RETURN POLICY: 90 DAYS\nWITH RECEIPT\nDID WE NAIL IT? TELL US AT\nHOMEDEPOT.COM/SURVEY',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

